// Common SliderProps
export function sliderConstantsProps(theme) {
    const slider = {
        breakpoints: {
            [theme.breakpoints['2xl']]: {
                perPage: 4,
                perMove: 4
            },
            [theme.breakpoints.xl]: {
                perPage: 4,
                perMove: 4
            },
            [theme.breakpoints.tablet]: {
                perPage: 3,
                perMove: 3,
                pagination: true,
                navigation: false,
                arrows: false
            },
            [theme.breakpoints.lg]: {
                perPage: 3,
                perMove: 3
            }
        },
        perPage: 5,
        perMove: 5,
        pagination: false,
        arrows: true,
        paginationVariant: 'bottom',
        speed: 1000,
        gap: 12
    };
    return slider;
}

//# sourceMappingURL=constants.js.map